import { render, staticRenderFns } from "./home-hunan.vue?vue&type=template&id=543892af&scoped=true&"
import script from "./home-hunan.vue?vue&type=script&lang=ts&"
export * from "./home-hunan.vue?vue&type=script&lang=ts&"
import style0 from "./home-hunan.vue?vue&type=style&index=0&id=543892af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543892af",
  null
  
)

export default component.exports